import * as React from "react";
const SvgFiRrFaceSleeping = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-sleeping_svg__a)">
      <path
        fill="#062147"
        d="M12 3a1 1 0 0 1 1-1h3a1.001 1.001 0 0 1 .8 1.6L15 6h1a1 1 0 1 1 0 2h-3a1.001 1.001 0 0 1-.8-1.6L14 4h-1a1 1 0 0 1-1-1m8-1h1l-1.8 2.4A.999.999 0 0 0 20 6h3a1 1 0 1 0 0-2h-1l1.8-2.4A.999.999 0 0 0 23 0h-3a1 1 0 1 0 0 2m-4.028 9.997c-.424-.002-.82-.219-1.179-.643a.999.999 0 1 0-1.527 1.292c.938 1.108 1.982 1.346 2.693 1.351h.02c1.029 0 2.077-.5 2.807-1.341a1.001 1.001 0 0 0-1.512-1.311c-.349.402-.845.652-1.295.652zm6.342-3.959a1 1 0 0 0-.689 1.234c.249.884.376 1.801.376 2.728 0 5.514-4.486 10-10 10S2 17.514 2 12c0-4.456 2.99-8.413 7.272-9.624A.999.999 0 1 0 8.727.452C3.589 1.905 0 6.654 0 12c0 6.617 5.383 12 12 12s12-5.383 12-12c0-1.11-.152-2.211-.452-3.272a1 1 0 0 0-1.234-.69M10.001 18a2 2 0 1 0 3.999.001A2 2 0 0 0 10 18m-.727-6.655c-.349.402-.845.652-1.295.652h-.007c-.424-.002-.82-.219-1.179-.643a1 1 0 1 0-1.527 1.292c.938 1.108 1.982 1.346 2.693 1.351h.02c1.029 0 2.077-.5 2.807-1.341a1.001 1.001 0 0 0-1.512-1.311"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-sleeping_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSleeping;
